import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { UNSET } from '../lib/unset';

// One metric-grid cell value with the band's three-state contract (#298): a
// resolved value renders as-is, a failed never-resolved source reads
// "Unavailable", and a still-loading one keeps the unset marker (`UNSET`). A value
// cached from an earlier poll wins over a failed refetch — stale beats blank.
//
// A `<span>` (each tile is a flex column, so it still stacks), so it may sit inside a
// button: the Fleet tiles that filter the Machines list are buttons (#6560).

export function StatValue(props: {
  value: string | number | undefined;
  error?: boolean | undefined;
}): JSX.Element {
  const failed = (): boolean => props.value === undefined && props.error === true;
  return (
    <span class="metric-grid__value" data-unavailable={failed() ? '' : undefined}>
      {props.value ?? (failed() ? t('fleet.stat_unavailable') : UNSET)}
    </span>
  );
}
